// extracted by mini-css-extract-plugin
export default {"buttons":"pB7TEyoML0XRmEPnmcAJ"};